import React from "react";
import OpcionDefecto from "../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../Common/Components/CheckDefecto";

const FormaPagos = ({ data, formaPagos, seleccionoFormaPago, selectCheckBox, selectCombo }) => {
    const arrayAux = formaPagos.filter(d => d.Checked && d.Activo);
    
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Forma de Pago"}</label>

                {formaPagos.map((item) => {
                    const referencia = `GFP-${item.Id}`;
                    let inactivo = item.Descripcion.toLowerCase().match(/ inactivo/);
                    return (
                        ((item.Activo && !inactivo)|| item.noDisponible) ? <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_FORMA_PAGO", item.Id)} /> : null
                    )
                })}

                <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"FormaPagoDefaultId"}
                    valorCombo={data.FormaPagoDefaultId}
                    valorChecked={data.FormaPagoDefaultInterfaz}
                    selectCombo={(value) => selectCombo("FormaPagoDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("FormaPagoDefaultInterfaz", value)}
                />

                {(!seleccionoFormaPago&&arrayAux.length===0)
                && <label className="error">{"Debe seleccionar al menos una forma de pago."}</label>}

            </div>
        </div>
    );
}

export default FormaPagos;